<template>
  <div class="main-body">
    <Modal
      v-model="cancelSalesOrderModal"
      title="取消销售订单"
      @on-ok="cancelOperate()"
      @on-cancel="cancelSalesOrderModal = false"
    >
      <Form
        @submit.native.prevent
        :model="formItem"
        ref="formItem"
        :label-width="80"
      >
        <FormItem label="取消理由">
          <Input
            type="text"
            v-model="formItem.canceledReason"
            placeholder="请输入取消销售订单的理由"
          />
        </FormItem>
      </Form>
    </Modal>
    <div class="left-panel">
      <h2>工厂</h2>
      <Select
        v-model="selectedFactoryId"
        @on-change="changeFactory"
      >
        <Option
          v-for="(option, index) in factoryList"
          :value="option._id"
          :key="index"
        >{{ option.name }}</Option>
      </Select>
      <div class="select-wrap">
        <h2>抵达时间</h2>
        <div style="display: flex; align-items: center">
          <Icon
            type="md-arrow-dropleft"
            size="24"
            style="cursor: pointer"
            @click="changeplanArrivedAt(null, null, '-')"
          />
          <DatePicker
            type="date"
            :open="dateCalOpen"
            :options="planArrivedAtOptions"
            @on-change="changeplanArrivedAt"
            @on-clickoutside="dateCalOpen = false"
          >
            <h1
              @click="dateCalOpen = !dateCalOpen"
              style="cursor: pointer"
            >
              {{ planArrivedAtDisplay }}
            </h1>
          </DatePicker>
          <Icon
            type="md-arrow-dropright"
            size="24"
            style="cursor: pointer"
            @click="changeplanArrivedAt(null, null, '+')"
          />
        </div>
      </div>
    </div>
    <div class="right-panel">
      <div class="select-wrap"></div>
      <div class="header">
        <div class="section-header-wrapper">
          <h3>
            {{
              getFactoryById(selectedFactoryId)
                ? getFactoryById(selectedFactoryId).name
                : null
            }}
          </h3>
        </div>
        <div style="display: flex; align-items: center">
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="15"
            @on-change="changePage"
            show-total
            simple
            style="margin-right: 24px"
          />
        </div>
      </div>
      <Table
        :columns="columns"
        :data="tableData"
        size="small"
        :draggable="true"
        :loading="loadingTableData"
      >
        <template
          slot-scope="{ row }"
          slot="productOperate"
        >
          <Dropdown
            transfer
            @on-click="changeProductOperate($event, row)"
            v-if="!row.startedAt"
          >
            <a href="javascript:void(0)">
              操作
              <Icon type="ios-arrow-down" />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem
                name="edit"
                class="operate-item"
                :disabled="row.startedAt ? true : false"
              >修改订单</DropdownItem>
              <DropdownItem
                class="operate-item"
                name="cancel"
                :disabled="row.startedAt ? true : false"
              >取消订单</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
    </div>
    <!-- <AddSalesOrderDrawer
      ref="AddSalesOrderDrawer"
      v-on:editSalesProd="getSPO"
    /> -->
    <PrintOrderDrawer
      ref="PrintOrderDrawer"
      :selectedRecipeDetail="selectedRecipeDetail"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import PrintOrderDrawer from "./PrintOrderDrawer.vue";
// import AddSalesOrderDrawer from "../SalesOrderPage/AddSalesOrderDrawer";
import { mapState, mapActions, mapGetters } from "vuex";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  name: "SalesOrder",
  components: { PrintOrderDrawer },
  data() {
    return {
      dayjs,
      formItem: {
        canceledReason: null,
      },
      cancelSalesOrderModal: false,
      page: 0,
      cancaleSalesOrderId: null,
      arrivedAtModel: false,
      semiMaterialWarning: false,
      noRecipeSemiMaterial: {},
      finishmModel: false,
      modelOrder: {},
      isCreateProductModel: false,
      tableHeight: 300,
      dateCalOpen: false,
      tableInputEditValue: null,
      editRow: null,
      editColumn: null,
      addNewDrawer: false,
      openedSalesOrderId: null,
      openedSalesOrderFactoryId: null,
      salesOrderDrawer: false,
      selectedFactoryId: null,
      loadingTableData: false,
      planArrivedAt: null,
      selectedRecipeDetail: [],
      planArrivedAtOptions: {
        shortcuts: [
          {
            text: "今天",
            value() {
              return new Date();
            },
          },
        ],
      },
      columns: [
        {
          title: "销售项目",
          key: "salesOrder",
          width: "200",
          render: (h, params) =>
            h(
              "span",
              params.row.sales.abbr
                ? params.row.sales.abbr
                : params.row.sales.name
            ),
        },
        {
          title: "吨数",
          key: "volPlan",
          sortable: true,
          render: (h, params) => {
            const volPlan = params.row.volPlan;
            return h("span", `${volPlan}`);
          },
        },
        {
          title: "需求时间",
          key: "planArrivedAt",
          sortable: true,
          render: (h, params) => {
            if (params.row.planArrivedAt) {
              if (this.planArrivedAt) {
                return h(
                  "span",
                  dayjs(params.row.planArrivedAt).format("MM-DD H:mm")
                );
              } else {
                return h(
                  "span",
                  dayjs(params.row.planArrivedAt).format("MM-DD H:mm")
                );
              }
            } else {
              return null;
            }
          },
        },
        {
          title: "计划生产时间",
          key: "producedAtPlan",
          render: (h, params) => {
            if (params.row.producedAtPlan) {
              return h(
                "span",
                dayjs(params.row.producedAtPlan).format("MM-DD HH:mm")
              );
            }
          },
        },
        {
          title: "生产开始",
          key: "startedAt",
          sortable: true,
          render: (h, params) => {
            return h(
              "span",
              params.row.startedAt
                ? dayjs(params.row.startedAt).format("MM-DD HH:mm")
                : ""
            );
          },
        },
        {
          title: "生产结束",
          key: "finishedAt",
          sortable: true,
          render: (h, params) => {
            return h(
              "span",
              params.row.finishedAt
                ? dayjs(params.row.finishedAt).format("MM-DD HH:mm")
                : ""
            );
          },
        },
        {
          title: "备注",
          key: "remark",
          render: (h, params) => h("span", params.row.remark),
        },
        {
          title: "创建时间",
          key: "createdAt",
          render: (h, params) =>
            h("span", dayjs(params.row.createdAt).format("MM-DD H:mm")),
        },
        {
          title: "生产操作",
          key: "productOperate",
          fixed: "right",
          align: "center",
          width: 100,
          render: (h, params) => {
            if (!params.row.startedAt) {
              return h(
                "span",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: async () => {
                      this.modelOrder = params.row;
                      if (!params.row.recipe) {
                        this.$Message.error("当前销售项目没有生产配方");
                      } else {
                        
                        // const semi = [];
                        // const raw = [];
                        // recipeSales.recipeSales.detail.forEach((x) => {
                        //   if (x.material.type === "semi") {
                        //     semi.push(x);
                        //   } else {
                        //     raw.push(x);
                        //   }
                        // });
                        // this.selectedRecipeDetail = semi.concat(raw);
                        this.$refs.PrintOrderDrawer.openDrawer(params.row);
                        // this.semiMaterialWarning = false;
                        // this.noRecipeSemiMaterial = {};
                        // this.isCreateProductModel = true;
                      }
                    },
                  },
                },
                "生产开始"
              );
            }
            if (params.row.startedAt && !params.row.finishedAt) {
              return h(
                "span",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    color: "#ed4014",
                    cursor: "pointer",
                  },
                  on: {
                    click: async () => {
                      this.modelOrder = params.row;
                      this.finishmModel = true;
                    },
                  },
                },
                "生产结束"
              );
            }
          },
        },
        {
          title: "运输操作",
          key: "carriageOperate",
          fixed: "right",
          align: "center",
          width: 100,
          render: (h, params) => {
            if (params.row.finishedAt && !params.row.arrivedAt) {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: async () => {
                      this.arrivedAtModel = true;
                      this.modelOrder = params.row;
                    },
                  },
                },
                "订单抵达"
              );
            } else {
              return h("span", "");
            }
          },
        },
        {
          title: "其他操作",
          key: "other-operate",
          fixed: "right",
          align: "center",
          width: 100,
          slot: "productOperate",
        },
      ],
      filterQuery: {},
      limit: 20,
      page: 0,
    };
  },
  computed: {
    ...mapGetters({
      getFactoryById: "factory/getFactoryById",
    }),
    ...mapState({
      factoryList: (state) => state.factory.factoryList,
      tableData: (state) => state.salesOrder.salesOrderList,
      totalRows: (state) => state.salesOrder.totalCounts,
    }),
    planArrivedAtDisplay() {
      if (this.planArrivedAt !== null) {
        return dayjs(this.planArrivedAt).format("M月D日").toString();
      } else {
        return "全部";
      }
    },
  },
  watch: {
  },
  methods: {
    ...mapActions({
      getSalesProdOrderList: "salesOrder/getSalesOrderListAction",
      changeSalesOrderProgress: "salesOrder/changeSalesOrderProgressAction",
      cancelSalesOrder: "salesOrder/cancelSalesProdOrderAction",
      updateSalesProdOrder: "salesOrder/updateSalesProdOrderAction",
      getFactorys: "factory/getFactorysAction",
      getCustomers: "customer/getCustomersAction",
    }),
    cancel(row) {
      this.cancelSalesOrderModal = true;
      this.formItem.canceledReason = null;
      this.cancaleSalesOrderId = row._id;
    },
    async cancelOperate() {
      await this.cancelSalesOrder({
        id: this.cancaleSalesOrderId,
        data: this.formItem,
      });
      this.$Message.success("取消成功!");
    },
    changePage(page) {
      if (page) this.page = page - 1;
      this.getSPO();
    },
    changeSuccess() {
      this.$Message.success("操作成功！");
      this.getSPO();
    },
    async changeProductOperate(name, row) {
      switch (name) {
        case "edit":
          this.$refs.AddSalesOrderDrawer.openDrawer(
            row.factory,
            row,
            "order",
            "salesProd"
          );
          break;
        case "cancel":
          this.cancel(row);
          break;
        default:
          break;
      }
    },
    // async startSalesOrder() {
    //   try {
    //     await this.changeSalesOrderProgress({
    //       id: this.modelOrder._id,
    //       data: { progress: "start" },
    //     });
    //   } catch (error) {
    //     return this.$Message.error(error);
    //   }
    //   this.changeSuccess();
    // },
    // async finishSalesOrder() {
    //   try {
    //     await this.changeSalesOrderProgress({
    //       id: this.modelOrder._id,
    //       data: { progress: "end" },
    //     });
    //   } catch (error) {
    //     return this.$Message.error(error);
    //   }
    //   this.changeSuccess();
    // },
    // async arrivedAtSalesOrder() {
    //   try {
    //     await this.changeSalesOrderProgress({
    //       id: this.modelOrder._id,
    //       data: { progress: "arrivedAt" },
    //     });
    //   } catch (error) {
    //     return this.$Message.error(error);
    //   }
    //   this.changeSuccess();
    // },
    changeplanArrivedAt(dateString, dateType, op) {
      if (op) {
        if (op === "+") {
          const base = this.planArrivedAt
            ? this.planArrivedAt
            : dayjs().toDate();
          this.planArrivedAt = dayjs(base).add(1, "day").toDate();
        } else if (op === "-") {
          const base2 = this.planArrivedAt
            ? this.planArrivedAt
            : dayjs().toDate();
          this.planArrivedAt = dayjs(base2).subtract(1, "day").toDate();
        }
      } else {
        if (!dateString) {
          this.planArrivedAt = null;
        } else {
          this.planArrivedAt = dayjs(dateString).toDate();
        }
      }

      this.dateCalOpen = false;
      this.filterQuery.date = dayjs(this.planArrivedAt).format("YYYY-MM-DD");
      this.getSPO();
    },
    async getSPO() {
      if (this.selectedFactoryId === null) return;
      this.loadingTableData = true;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.selectedFactoryId) {
        this.filterQuery.factory = this.selectedFactoryId;
      }
      this.$router.push({
        path: `/home/sales_prod_order`,
        query: {
          date: this.filterQuery.date,
        },
      });
      try {
        await this.getSalesProdOrderList(this.filterQuery);
      } catch (error) {
        this.$Message.error(eror);
      }
      this.loadingTableData = false;
    },
    changeFactory(value) {
      this.selectedFactoryId = value;
      this.getSPO();
    },
  },
  created() {
    
  },
  async mounted() {
    let queryUrl = this.$route.query;
    this.planArrivedAt = new Date();

    if (queryUrl.date) {
      this.filterQuery.date = queryUrl.date;
      this.planArrivedAt = queryUrl.date;
    } else {
      this.filterQuery.date = dayjs(this.planArrivedAt).format("YYYY-MM-DD");
    }

    await this.getFactorys();
    this.selectedFactoryId = this.factoryList[0]?._id;
    this.getSPO();
    // this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    // window.onresize = () => {
    //   this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    // };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.left-panel
  height 100%
  width 200px
  float left
  border 1px solid lightgray
  border-radius 4px
  overflow-y auto
  padding 12px

  .select-wrap
    margin-top 25px

.right-panel
  width calc(100% - 200px)
  float left
  overflow-y auto
  padding 0 12px

  .header
    display flex
    margin-bottom 10px
    justify-content space-between

.btn
  display inline-block
  width 48px
  height 32px
  line-height 32px
  text-align center
  border 1px solid lightgray
  border-radius 4px
  margin-right 4px
  cursor pointer
  -webkit-user-select none
  -moz-user-select none
  -ms-user-select none
  user-select none

.section-wrapper
  overflow auto

.section-header-wrapper
  height 36px
  display flex
  align-items center
  justify-content space-between

  .ivu-btn, .ivu-btn-primary
    margin-left 12px

.page
  margin-left auto

.table-wrapper
  width 100%
  height 100%

.operate-item
  color #71777c

.oreder-content
  .order-status
    font-size 16px
    display flex
    justify-content space-between
    margin-bottom 10px

    .title
      margin-bottom 10px
      display flex
      align-items center

      div:last-child
        margin-left 15px

  .order-table
    margin 20px auto

    .header
      display flex
      align-items center
      margin-bottom 10px
      justify-content space-between
</style>
